<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h2>{{ $t("data-export-validation.file-status") }}</h2>
          <FeedbackTable :items="feedback"></FeedbackTable>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <h2>
            {{ $t("data-export-validation.common.file-information") }}
          </h2>
          <v-simple-table class="keyval-table">
            <tbody>
              <tr>
                <td>
                  {{ $t("data-export-validation.common.file-type") }}
                </td>
                <td>{{ fileType }}</td>
              </tr>
              <tr>
                <td>
                  {{ $t("data-export-validation.common.file-date") }}
                </td>
                <td>{{ fileDate }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>
      <template v-for="(property, pIndex) in this.content">
        <div :key="'property' + pIndex">
          <v-row>
            <v-col>
              <h2>
                {{ $t("data-export-validation.common.property") }}
              </h2>
              <v-simple-table class="keyval-table">
                <tbody>
                  <tr>
                    <td>
                      {{ $t("data-export-validation.common.property") }}
                    </td>
                    <td>
                      {{ property.propertyId }} |
                      {{ property.propertyAddress }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {{ $t("data-export-validation.common.billing-period") }}
                    </td>
                    <td>
                      {{ property.billingPeriodStart }} -
                      {{ property.billingPeriodEnd }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <h3>
                {{ $t("data-export-validation.common.allocations") }}
              </h3>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>
                      {{ $t("data-export-validation.common.cost-centre") }}
                    </th>
                    <th>
                      {{ $t("data-export-validation.common.allocation") }}
                    </th>
                    <th>
                      {{
                        $t("data-export-validation.common.proportion") + " (‰)"
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(allocation,
                    allocationIndex) in property.allocations"
                    :key="'allocation' + allocationIndex"
                  >
                    <td>
                      [{{ allocation.provider.id }}]
                      {{ allocation.provider.title }}
                    </td>
                    <td>
                      [{{ allocation.consumer.id }}]
                      {{ allocation.consumer.title }}
                    </td>
                    <td>
                      {{ allocation.proportion }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div>
                <h3 style="display: inline; margin-right: 2rem">
                  {{ $t("data-export-validation.common.distribution") }}
                </h3>
                <vue-json-to-csv
                  class="download-csv"
                  :json-data="property.costDistribution"
                  :labels="headersForCsv"
                  separator=";"
                  csv-title="export-preview"
                  >{{
                    $t("data-export-validation.download-csv-preview")
                  }}</vue-json-to-csv
                >
              </div>
              <v-data-table
                :headers="headers"
                :items="property.costDistribution"
                :sort-by="['type', 'unit', 'occupancyPeriodStart']"
                multi-sort
                hide-default-footer
                disable-pagination
              ></v-data-table>
            </v-col>
          </v-row>
        </div>
      </template>
    </v-container>
  </div>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
import FeedbackTable from "../../../../common/feedback/FeedbackTable.vue";

export default {
  name: "CommonExportValidation",
  components: { FeedbackTable, VueJsonToCsv },
  props: {
    fileType: String,
    fileDate: String,
    feedback: Array,
    content: Array
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("data-export-validation.common.type"),
          value: "type"
        },
        {
          text: this.$t("data-export-validation.common.unit"),
          value: "unit"
        },
        {
          text: this.$t("data-export-validation.common.period-start"),
          value: "occupancyPeriodStart"
        },
        {
          text: this.$t("data-export-validation.common.period-end"),
          value: "occupancyPeriodEnd"
        },
        {
          text: this.$t("data-export-validation.common.occupant"),
          value: "occupant"
        },
        {
          text: this.$t("data-export-validation.common.proportion") + " (‰)",
          value: "proportion"
        }
      ]
    };
  },
  computed: {
    headersForCsv() {
      let result = {};
      for (const header of this.headers) {
        result[header.value] = { title: header.text };
      }
      return result;
    }
  }
};
</script>

<style scoped>
.keyval-table td:nth-child(1) {
  width: 200px;
}
.download-csv {
  text-decoration: none;
  font-size: 14px;
}
.download-csv:hover {
  text-decoration: underline;
  cursor: pointer;
}
</style>
